/**
 * CSV依頼データ
 */
export default class CsvRequest {
    /** NDFP検査依頼ID */
    requestId = ""
    /** ステータス */
    status = ""
    /** 最終更新日時 */
    lastModifiedAt = ""
    /** キャンセル日 */
    cancelOn = ""
    /** キャンセル理由 */
    cancelReason = ""
    /** 依頼登録日 */
    requestRegistrationOn = ""
    /** 推奨予定日 */
    recommendedScheduledOn = ""
    /** 依頼確定日(検査所へ出力日) */
    requestConfirmationOn = ""
    /** サンプル到着予定日 */
    arriveOn = ""
    /** 検体番号 */
    specimenNo = ""
    /** 商品名 */
    productName = ""
    /** カテゴリー */
    category = ""
    /** 可食重量 */
    edibleWeight = ""
    /** オプション単独 */
    optionSingle = ""
    /** オプション検査１(種類) */
    optionInspection1 = ""
    /** オプション検査２(種類) */
    optionInspection2 = ""
    /** オプション検査３(種類) */
    optionInspection3 = ""
    /** オプション検査４(種類) */
    optionInspection4 = ""
    /** 添付物１ */
    additive1 = ""
    /** 添付物２ */
    additive2 = ""
    /** 添付物３ */
    additive3 = ""
    /** 添付物４ */
    additive4 = ""
    /** 添付物５ */
    additive5 = ""
    /** 添付物６ */
    additive6 = ""
    /** 除外する部位 */
    excludedParts = ""
    /** 備考 */
    note = ""
    /** 検査種類 */
    inspectionType = ""
    /** 検査所名(略称) */
    laboratoryName = ""
    /** 会社名 */
    companyName = ""
    /** 工場名 */
    factoryName = ""
    /** 記入者 */
    writer = ""
    /** メーカーTEL */
    manufacturerTel = ""
    /** ベンダーコード */
    vendorCode = ""
    /** 得意先コード */
    customerCode = ""
    /** 可食重量の単位 */
    unitOfEdibleWeight = ""

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<CsvRequest>) {
        Object.assign(this, init)
    }

    /**
     * ヘッダーを取得する
     */
    static getHeader() {
        return ["NDFP検査依頼ID",
                "ステータス",
                "最終更新日時",
                "キャンセル日",
                "キャンセル理由",
                "依頼登録日",
                "推奨予定日",
                "依頼確定日(検査所へ出力日)",
                "サンプル到着予定日",
                "検体番号",
                "商品名",
                "カテゴリー",
                "可食重量",
                "オプション単独",
                "オプション検査１(種類)",
                "オプション検査２(種類)",
                "オプション検査３(種類)",
                "オプション検査４(種類)",
                "添付物１",
                "添付物２",
                "添付物３",
                "添付物４",
                "添付物５",
                "添付物６",
                "除外する部位",
                "備考",
                "検査種類",
                "検査所名(略称)",
                "会社名",
                "工場名",
                "記入者",
                "メーカーTEL",
                "ベンダーコード",
                "得意先コード",
        ]
    }
}
